import { axios } from '@/utils/request'

const api = {
  kaojiList: '/adminapi/kaojiexame/kaojilist',
  kaojiYundongyuanList: '/adminapi/kaojiexame/kaojiYundongyuanList',
  mingdanSave: '/adminapi/kaojiexame/mingdanSave',
  score1Save: '/adminapi/kaojiexame/score1Save',
  score1List: '/adminapi/kaojiexame/score1List',
  score2Save: '/adminapi/kaojiexame/score2Save',
  score2List: '/adminapi/kaojiexame/score2List',
  scoreFormDetail: '/adminapi/kaojiexame/scoreFormDetail',
  scoreConfirm: '/adminapi/kaojiexame/scoreConfirm',
  getAllCertUrls: '/adminapi/kaojiexame/getAllCertUrls',
  setCertFace: '/adminapi/kaojiexame/setCertFace',
  setHuankaoStatus: '/adminapi/kaojiexame/setHuankaoStatus',
  scoreSimpleSave: '/adminapi/kaojiexame/scoreSimpleSave',
  scoreImport: '/adminapi/kaojiexame/scoreImport',
  setYearType: '/adminapi/kaojiexame/setYearType',
  setCurrent: '/adminapi/kaojiexame/setCurrent',
  setSubjectStatus: '/adminapi/kaojiexame/setSubjectStatus',
  kaojiMemberDownload: '/adminapi/kaojiexame/kaojiMemberDownload',
}

export default api

export function getKaojiList(parameter) {
  return axios({
    url: api.kaojiList,
    method: 'get',
    params: parameter
  })
}
export function getKaojiYundongyuanList(parameter) {
  return axios({
    url: api.kaojiYundongyuanList,
    method: 'get',
    params: parameter
  })
}
export function getScore1List(parameter) {
  return axios({
    url: api.score1List,
    method: 'get',
    params: parameter
  })
}
export function getScore2List(parameter) {
  return axios({
    url: api.score2List,
    method: 'get',
    params: parameter
  })
}
export function scoreFormDetail(parameter) {
  return axios({
    url: api.scoreFormDetail,
    method: 'get',
    params: parameter
  })
}
export function mingdanSave(parameter) {
  return axios({
    url: api.mingdanSave,
    method: 'post',
    data: parameter
  })
}
export function score1Save(parameter) {
  return axios({
    url: api.score1Save,
    method: 'post',
    data: parameter
  })
}
export function score2Save(parameter) {
  return axios({
    url: api.score2Save,
    method: 'post',
    data: parameter
  })
}
export function scoreConfirm(parameter) {
  return axios({
    url: api.scoreConfirm,
    method: 'post',
    data: parameter
  })
}
export function getAllCertUrls(parameter) {
  return axios({
    url: api.getAllCertUrls,
    method: 'post',
    data: parameter
  })
}
export function setCertFace(parameter) {
  return axios({
    url: api.setCertFace,
    method: 'post',
    data: parameter
  })
}

export function setHuankaoStatus(parameter) {
  return axios({
    url: api.setHuankaoStatus,
    method: 'post',
    data: parameter
  })
}

export function scoreSimpleSave(parameter) {
  return axios({
    url: api.scoreSimpleSave,
    method: 'post',
    data: parameter
  })
}

export function scoreImport(parameter) {
  return axios({
    url: api.scoreImport,
    method: 'post',
    data: parameter
  })
}

export function setYearType(parameter) {
  return axios({
    url: api.setYearType,
    method: 'post',
    data: parameter
  })
}

export function setCurrent(parameter) {
  return axios({
      url: api.setCurrent,
      method: 'post',
      data: parameter
  })
}

export function setSubjectStatus(parameter) {
  return axios({
      url: api.setSubjectStatus,
      method: 'post',
      data: parameter
  })
}
export function kaojiMemberDownload(parameter) {
  return axios({
      url: api.kaojiMemberDownload,
      method: 'post',
      data: parameter
  })
}